export const shopCategoryMeta = {
  flower: {
    title: "Premium Cannabis Flower in San Jose | Purple Lotus",
    description:
      "Shop premium cannabis flower at Purple Lotus. Choose from indoor, outdoor, and exotic strains. Fast pickup and delivery in San Jose.",
  },
  "pre-roll": {
    title: "Cannabis Pre-Rolls in San Jose | Purple Lotus",
    description:
      "Shop infused and classic cannabis pre-rolls at Purple Lotus. Smooth joints available for fast pickup or delivery in San Jose.",
  },
  extract: {
    title: "Cannabis Extracts & Concentrates in San Jose | Purple Lotus",
    description:
      "Shop high-quality cannabis extracts at Purple Lotus, including live resin, rosin, shatter, and sauce. Pickup or delivery in San Jose.",
  },
  vape: {
    title: "Cannabis Vapes & Vape Carts in San Jose | Purple Lotus",
    description:
      "Find top-tier THC vape cartridges and pods at Purple Lotus. Shop leading cannabis vape brands for delivery or pickup in San Jose.",
  },
  edible: {
    title: "Cannabis Edibles in San Jose | Purple Lotus",
    description:
      "Browse San Jose’s tastiest cannabis edibles—gummies, chocolates, beverages, and more. Available for pickup or delivery at Purple Lotus.",
  },
  tincture: {
    title: "Cannabis Tinctures in San Jose | Purple Lotus",
    description:
      "Shop full-spectrum cannabis tinctures and fast-acting THC/CBD drops at Purple Lotus. Convenient pickup or delivery in San Jose.",
  },
  topical: {
    title: "Cannabis Topicals in San Jose | Purple Lotus",
    description:
      "Discover soothing cannabis topicals at Purple Lotus. Shop THC and CBD creams, balms, and salves for local pickup or delivery in San Jose.",
  },
  gear: {
    title: "Cannabis Accessories & Gear in San Jose | Purple Lotus",
    description:
      "Get essential cannabis accessories at Purple Lotus—rolling papers, grinders, pipes, and more. Pickup available in San Jose.",
  },
  merch: {
    title: "Purple Lotus Cannabis Merchandise & Apparel",
    description:
      "Rep Purple Lotus with official branded merch, apparel, and gear. Shop online and support San Jose’s favorite cannabis dispensary.",
  },
  "edible:drinks": {
    title: "Cannabis Beverages & Drinks in San Jose | Purple Lotus",
    description:
      "Refresh with cannabis-infused beverages at Purple Lotus. Shop THC and CBD drinks for delivery or pickup in San Jose.",
  },
  "edible:candies": {
    title: "Cannabis Candies & Gummies in San Jose | Purple Lotus",
    description:
      "Satisfy your sweet tooth with cannabis candies at Purple Lotus. Shop THC and CBD gummies for fast pickup or delivery in San Jose.",
  },
  "edible:chocolates": {
    title: "Cannabis Chocolates in San Jose | Purple Lotus",
    description:
      "Indulge in delicious cannabis chocolates at Purple Lotus. Shop THC and CBD chocolate bars for local pickup or delivery in San Jose.",
  },
  "edible:Baked Goods": {
    title: "Cannabis Edible Baked Goods in San Jose | Purple Lotus",
    description: "Browse cannabis baked goods edible at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "edible:Capsules": {
    title: "Cannabis Edible THC & CBD Capsules in San Jose | Purple Lotus",
    description: "Browse cannabis capsules edible at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "edible:Spreads": {
    title: "Cannabis Edible THC Spreads in San Jose | Purple Lotus",
    description: "Browse cannabis spreads edible at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "edible:Tablets": {
    title: "Cannabis Edible THC & CBD Tablets in San Jose | Purple Lotus",
    description: "Browse cannabis tablets edible at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "extract:Diamonds/Crystals": {
    title: "Cannabis Diamond/Crystal Extract in San Jose | Purple Lotus",
    description: "Browse cannabis diamonds/crystals extract at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "extract:Hash": {
    title: "Cannabis Hash Extract in San Jose | Purple Lotus",
    description: "Browse cannabis hash extract at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "extract:Live Resins": {
    title: "Cannabis Live Resin Extract in San Jose | Purple Lotus",
    description: "Browse live cannabis resins extract at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "extract:Rick Simpson Oil (RSO)": {
    title: "Cannabis Rick Simpson Oil Extract in San Jose | Purple Lotus",
    description: "Browse rick simpson oil (rso) cannabis extract at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "extract:Rosins": {
    title: "Cannabis Rosin Extract in San Jose | Purple Lotus",
    description: "Browse cannabis rosins extract at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "extract:Sauces": {
    title: "Cannabis Sauce Extract in San Jose | Purple Lotus",
    description: "Browse cannabis sauces at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "extract:Shatters": {
    title: "Cannabis Shatter Extract in San Jose | Purple Lotus",
    description: "Browse cannabis shatter extract at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "extract:Waxes": {
    title: "Cannabis Wax Extract in San Jose | Purple Lotus",
    description: "Browse cannabis wax extract at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "flower:Ground Flower": {
    title: "Ground Cannabis Flower in San Jose | Purple Lotus",
    description: "Browse ground cannabis flower at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "flower:Indoor": {
    title: "Indoor Cannabis Flower in San Jose | Purple Lotus",
    description: "Browse indoor cannabis flower at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "flower:Infused Flower": {
    title: "Infused Cannabis Flower in San Jose | Purple Lotus",
    description: "Browse infused cannabis flower at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "flower:Premium": {
    title: "Premium Cannabis Flower in San Jose | Purple Lotus",
    description: "Browse premium cannabis flower at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "flower:Shake": {
    title: "Cannabis Shake in San Jose | Purple Lotus",
    description: "Browse cannabis shake at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "flower:Smalls": {
    title: "Cannabis Smalls in San Jose | Purple Lotus",
    description: "Browse small cannabis flower at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "gear:Accessories": {
    title: "Cannabis Accessories in San Jose | Purple Lotus",
    description: "Browse cannabis accessories at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "gear:Papers": {
    title: "Cannabis Papers in San Jose | Purple Lotus",
    description: "Browse cannabis papers at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "gear:Tips": {
    title: "Cannabis Tips in San Jose | Purple Lotus",
    description: "Browse cannabis tips at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "gear:Vaporizers": {
    title: "Cannabis Vaporizers in San Jose | Purple Lotus",
    description: "Browse cannabis vaporizers at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "gear:Wraps": {
    title: "Cannabis Wraps in San Jose | Purple Lotus",
    description: "Browse cannabis wraps at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "merch:Clothing": {
    title: "Clothing Merch in San Jose | Purple Lotus",
    description: "Browse clothing merch at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "pre-roll:Blunt Packs": {
    title: "Cannabis Blunt Packs in San Jose | Purple Lotus",
    description: "Browse cannabis blunt packs at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "pre-roll:Blunts": {
    title: "Cannabis Blunts in San Jose | Purple Lotus",
    description: "Browse cannabis blunts at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "pre-roll:Infused": {
    title: "Infused Cannabis Pre Rolls in San Jose | Purple Lotus",
    description: "Browse infused cannabis pre rolls at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "pre-roll:Infused Blunts": {
    title: "Infused Cannabis Blunts in San Jose | Purple Lotus",
    description: "Browse infused cannabis blunts at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "pre-roll:Infused Packs": {
    title: "Infused Pre Roll Packs in San Jose | Purple Lotus",
    description: "Browse infused cannabis pre roll packs at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "pre-roll:Pre Roll Packs": {
    title: "Cannabis Pre Roll Packs in San Jose | Purple Lotus",
    description: "Browse cannabis pre roll packs at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "pre-roll:Pre Rolls": {
    title: "Cannabis Pre Rolls in San Jose | Purple Lotus",
    description: "Browse cannabis pre rolls at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "sale": {
    title: "Cannabis Deals and Sales in San Jose | Purple Lotus",
    description: "Shop top cannabis deals and special discounts at Purple Lotus. Limited-time offers available in San Jose.",
  },
  "tincture:Mixes": {
    title: "Cannabis Tincture Mixes in San Jose | Purple Lotus",
    description: "Browse cannabis tincture mixes at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "tincture:Sublinguals": {
    title: "Cannabis Sublinguals in San Jose | Purple Lotus",
    description: "Browse cannabis sublinguals at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "topical:Balms": {
    title: "Cannabis Topical Balms in San Jose | Purple Lotus",
    description: "Browse cannabis topical balms at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "topical:Oils": {
    title: "Cannabis Oils in San Jose | Purple Lotus",
    description: "Browse cannabis oils at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "topical:Patches": {
    title: "Cannabis Topical Patches in San Jose | Purple Lotus",
    description: "Browse cannabis topical patches at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "topical:Roll - Ons": {
    title: "Cannabis Topical Roll - Ons in San Jose | Purple Lotus",
    description: "Browse cannabis topical roll - ons at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "topical:Roll-Ons": {
    title: "Cannabis Topcical Roll-Ons in San Jose | Purple Lotus",
    description: "Browse cannabis topical roll-ons at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "vape:Cartridges": {
    title: "Cannabis Vape Cartridges in San Jose | Purple Lotus",
    description: "Browse cannabis vape cartridges at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "vape:Disposables": {
    title: "Cannabis Disposable Vapes in San Jose | Purple Lotus",
    description: "Browse cannabis disposable vapes at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
  "vape:Specialty Pods": {
    title: "Specialty Cannabis Vape Pods in San Jose | Purple Lotus",
    description: "Browse specialty cannabis vape pods at Purple Lotus. Available for delivery or pickup in San Jose.",
  },
};

export function getShopCategoryMeta(category) {
  if (!category) return defaultMeta;

  // Decode URI (e.g., "Ground%20Flower" => "Ground Flower")
  const decoded = decodeURIComponent(category);

  // Try exact match first
  if (shopCategoryMeta[decoded]) {
    return shopCategoryMeta[decoded];
  }

  // Normalize: lowercase and strip non-alphanumerics for fuzzy match
  const normalized = decoded.toLowerCase().replace(/\s+/g, " ").trim();

  const matchKey = Object.keys(shopCategoryMeta).find((key) => {
    return key.toLowerCase().replace(/\s+/g, " ").trim() === normalized;
  });

  return (
    (matchKey && shopCategoryMeta[matchKey]) || {
      title: "Shop Cannabis Products in San Jose | Purple Lotus",
      description:
        "Browse high-quality cannabis products available for delivery or pickup at Purple Lotus in San Jose.",
    }
  );
}
